/*
 * action types
 */

export const REPLACE_REFERRALS = "REPLACE_REFERRALS";
export const CLEAR_REFERRALS = "CLEAR_REFERRALS";
export const SET_REFERRALS_FILTERS = "SET_REFERRALS_FILTERS";
export const SET_REFERRALS_PAGESIZE = "SET_REFERRALS_PAGESIZE";
export const SET_REFERRALS_PAGENUMBER = "SET_REFERRALS_PAGENUMBER";
export const SELECT_REFERRAL = "SELECT_REFERRAL";
export const SELECT_ALL_REFERRALS = "SELECT_ALL_REFERRALS";
export const UNSELECT_REFERRAL = "UNSELECT_REFERRAL";
export const UNSELECT_ALL_REFERRALS = "UNSELECT_ALL_REFERRALS";

/*
 * action creators
 */

export const Replace = (values, totalResults, totalPage) => ({ 
    type : REPLACE_REFERRALS,
    referrals: values,
    totalResults,
    totalPage
});

export const Clear = () => ({
    type: CLEAR_REFERRALS
})

export const SetPageSize = (pageSize) => ({
    type: SET_REFERRALS_PAGESIZE,
    pageSize
})

export const SetPageNumber = (pageNumber) => ({
    type: SET_REFERRALS_PAGENUMBER,
    pageNumber
})

export const SetFilters = (filters) => ({
    type: SET_REFERRALS_FILTERS,
    filters
})

export const selectReferral = (referralId) => ({
    type: SELECT_REFERRAL,
    referralId
})

export const selectAllReferrals = () => ({
    type: SELECT_ALL_REFERRALS
})

export const unSelectReferral = (referralId) => ({
    type: UNSELECT_REFERRAL,
    referralId
})

export const unSelectAllReferrals = () => ({
    type: UNSELECT_ALL_REFERRALS
})